import { useTranslation } from 'react-i18next';

import { useAuthUser } from 'auth/hooks';
import { CompanySettingsLayout, PartFinderFamilies } from 'companySettings/components';
import { canAccessPartFinderSetup } from 'companySettings/utils';
import { Error, PageLayout } from 'core/components';
import { StatusCode } from 'core/constants';

export const PartFinderFamiliesPage = () => {
  const { t } = useTranslation();

  const { user, isLoading } = useAuthUser();

  const title = t('titlePartFinderFamilies');

  if (isLoading) {
    return <PageLayout title={title} />;
  }

  if (!canAccessPartFinderSetup(user)) {
    return (
      <PageLayout title={title}>
        <Error statusCode={StatusCode.ACCESS_DENIED} />
      </PageLayout>
    );
  }

  return (
    <CompanySettingsLayout title={title}>
      <PartFinderFamilies />
    </CompanySettingsLayout>
  );
};
